import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { tbUrl } from '../api/api';
import { authFetchProxy } from '../authFetch';
import clusterDummyData from '../data/clusterDummyData';

// Thunk to fetch the full API response
   export const fetchClusterData = createAsyncThunk(
     'cluster/fetchData',
     async () => {
       const res = await authFetchProxy('/aggregator/');  // maps to :30004/
       console.log("apis response :", res);
       if (!res.ok) throw new Error(`Network error ${res.status}`);
       return res.json();
     }
   );
// export const fetchClusterData = createAsyncThunk(
//    'cluster/fetchData',
//    async () => {
//      // TEMP: use local dummy data while the real API is down
//      return clusterDummyData;
//    }
//  );

const clusterSlice = createSlice({
  name: 'cluster',
  initialState: {
    data: null,
    loading: 'idle',   // 'idle' | 'pending' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchClusterData.pending, state => {
        state.loading = 'pending';
        state.error = null;
      })
      .addCase(fetchClusterData.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        state.data = action.payload;   // entire JSON, so data.manager…
      })
      .addCase(fetchClusterData.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.error.message;
      });
  },
});

export default clusterSlice.reducer;
